import api from '../..'

export const editUserRole = (userId: number, user: any) => {
  return api.post(`administration/users/${userId}/roles/`, { user }).then(({ data }) => data)
}
